import { ReactNode, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.scss';
import heroBg1 from '../images/hero-bg1.jpg';
import heroBg2 from '../images/hero-bg2.jpg';
import heroBg3 from '../images/hero-bg3.jpg';
import company from '../images/company.png';
import companyBl from '../images/company_bl.png';
import box from '../images/box.png';
import boxBl from '../images/box_bl.png';
import blog from '../images/blog.png';
import blogBl from '../images/blog_bl.png';
import mall from '../images/mall.png';
import mallBl from '../images/mall_bl.png';
import pf01 from '../images/portfolio/pf-01-a4-flyer.jpg';
import pf02 from '../images/portfolio/pf-02-hand-bag.jpg';
import pf03 from '../images/portfolio/pf-03-box-set.jpg';
import pf04 from '../images/portfolio/pf-04-stationery.jpg';
import pf05 from '../images/portfolio/pf-05-gift-box.jpg';
import pf06 from '../images/portfolio/pf-06-classic-bag.jpg';
import pf07 from '../images/portfolio/pf-07-identity-kit.jpg';
import pf08 from '../images/portfolio/pf-08-paperbag-branding.jpg';
import pf09 from '../images/portfolio/pf-09-elegant-bag.jpg';
import pf10 from '../images/portfolio/pf-10-leaflet.jpg';
import pf11 from '../images/portfolio/pf-11-mail-box.jpg';
import pf12 from '../images/portfolio/pf-12-kraft-grid.jpg';
import pf13 from '../images/portfolio/pf-13-hanger-box.jpg';
import pf14 from '../images/portfolio/pf-14-mail-box2.jpg';
import pf15 from '../images/portfolio/pf-15-vertical-bag.jpg';
import pf16 from '../images/portfolio/pf-16-isometric-bag.jpg';

interface HeroSlide {
  id: string;
  scrim: string;
  title: ReactNode;
  sub: string;
  image: string;
  alt: string;
  primary: { label: string; to: string; icon: string };
  secondary: { label: string; to: string; icon: string };
}

const HERO_SLIDES: HeroSlide[] = [
  {
    id: 's1',
    scrim: styles.scrim1,
    title: (
      <>
        디자인 포트폴리오와
        <br />
        견적·주문·결제를 <span className={styles.accent}>한 곳에서</span>
      </>
    ),
    sub: '디자인 기획부터 인쇄·가공까지, 원스톱으로 제공하는 통합 제작 서비스를 만나보세요.',
    image: heroBg1,
    alt: 'G-WORKS 브랜딩 디자인 비주얼',
    primary: { label: '빠른 견적 문의', to: '/quote', icon: 'fa-solid fa-file-pen' },
    secondary: { label: '포트폴리오 보러가기', to: '/works', icon: 'fa-solid fa-images' },
  },
  {
    id: 's2',
    scrim: styles.scrim2,
    title: (
      <>
        인쇄부터 후가공까지
        <br />
        원스톱 <span className={styles.accent}>맞춤 제작</span>
      </>
    ),
    sub: '소량 인쇄는 빠르게, 대량 인쇄는 더 저렴하게. 후가공까지 한 번에 해결하는 프리미엄 제작 서비스입니다.',
    image: heroBg2,
    alt: 'G-WORKS 크리에이티브 스튜디오 비주얼',
    primary: { label: '제작 서비스 보기', to: '/order', icon: 'fa-solid fa-file-pen' },
    secondary: { label: '주문/견적 안내', to: '/quote', icon: 'fa-solid fa-pen-to-square' },
  },
  {
    id: 's3',
    scrim: styles.scrim3,
    title: (
      <>
        브랜드 가치를 높이는
        <br />
        패키지 <span className={styles.accent}>기획 전문 기업</span>
      </>
    ),
    sub: '박스·쇼핑백·라벨까지, 브랜드에 맞는 포장을 기획하고 제작합니다. 샘플 시안 제작도 빠르게 진행해 드립니다.',
    image: heroBg3,
    alt: 'G-WORKS 판촉물 및 패키지 디자인 비주얼',
    primary: { label: '포장기획 보러가기', to: '/order', icon: 'fa-solid fa-box' },
    secondary: { label: '주문/견적 안내', to: '/quote', icon: 'fa-solid fa-pen-to-square' },
  },
];

interface PortfolioItem {
  size: 'hero' | 'mid' | 'normal';
  image: string;
  alt: string;
  tag: string;
  title: string;
  desc: string;
}

const PORTFOLIO_ITEMS: PortfolioItem[] = [
  { size: 'hero', image: pf01, alt: 'A4 플라이어 인쇄물 목업', tag: '카달로그 디자인', title: 'A4 플라이어 · 카달로그 디자인', desc: '프리미엄 인쇄물 기획부터 제작까지' },
  { size: 'normal', image: pf02, alt: '핸드 쇼핑백 목업', tag: '인쇄물 디자인', title: '핸드 쇼핑백 리뉴얼', desc: '브랜드 감성을 담은 패키지 캐리어' },
  { size: 'normal', image: pf03, alt: '카드보드 박스 세트 목업', tag: '패키지 디자인', title: '카드보드 박스 세트', desc: '구조 기획부터 디자인·제작까지' },
  { size: 'normal', image: pf04, alt: '오버헤드 스테이셔너리 목업', tag: '브랜딩 디자인', title: '오버헤드 사무용품 세트', desc: '기업 아이덴티티를 적용한 문구 시스템' },
  { size: 'normal', image: pf05, alt: '크라프트 기프트 박스 목업', tag: '브랜딩 디자인', title: '크라프트 기프트 박스', desc: '친환경 소재 기반 프리미엄 포장' },
  { size: 'mid', image: pf06, alt: '클래식 쇼핑백 목업', tag: '브랜딩 디자인', title: '클래식 쇼핑백 제작', desc: '소량부터 대량까지 빠른 제작' },
  { size: 'normal', image: pf07, alt: '브랜드 아이덴티티 키트 목업', tag: '브랜딩 디자인', title: '브랜드 아이덴티티 키트', desc: '접점 전체를 설계하는 BI/BX 구축' },
  { size: 'normal', image: pf08, alt: '페이퍼백 브랜딩 목업', tag: '브랜딩 디자인', title: '페이퍼백 브랜딩', desc: '종류별 맞춤 사이즈·시공 제안' },
  { size: 'normal', image: pf09, alt: '엘레강트 쇼핑백 목업', tag: '브랜딩 디자인', title: '엘레강트 쇼핑백', desc: '감각적인 마감 디테일 제안' },
  { size: 'mid', image: pf10, alt: 'Print 포트폴리오 목업', tag: '브랜딩 디자인', title: '4단 리플렛 구성', desc: '접이식 구조로 휴대성을 높인 안내물' },
  { size: 'normal', image: pf11, alt: 'Package 포트폴리오 목업', tag: '브랜딩 디자인', title: '크라프트 우편 박스', desc: '언박싱 경험을 설계한 택배 박스' },
  { size: 'normal', image: pf12, alt: 'Kraft 포트폴리오 목업', tag: '브랜딩 디자인', title: '크라프트 박스 그리드', desc: '규격별로 조합하는 패키지 라인업' },
  { size: 'normal', image: pf13, alt: 'Kraft 포트폴리오 목업', tag: '브랜딩 디자인', title: '행거형 크라프트 박스', desc: '매장 진열에 최적화된 행거 포장' },
  { size: 'normal', image: pf14, alt: 'Kraft 포트폴리오 목업', tag: '브랜딩 디자인', title: '크라프트 메일 박스', desc: '심플한 마감의 감성 선물 포장' },
  { size: 'normal', image: pf15, alt: 'Bag 포트폴리오 목업', tag: '브랜딩 디자인', title: '세로형 페이퍼백', desc: '브랜드 컬러를 활용한 캐리어' },
  { size: 'mid', image: pf16, alt: 'Bag 포트폴리오 목업', tag: '브랜딩 디자인', title: '아이소메트릭 쇼핑백', desc: '구조와 마감을 함께 제안하는 백' },
];

interface ServiceLink {
  to: string; 
  label: string;
  icon: string;
  iconHover: string;
}

const SERVICE_LINKS: ServiceLink[] = [
  { to: '/company', label: '회사소개', icon: company, iconHover: companyBl },
  { to: '/portfolio', label: '박스제작 가이드', icon: box, iconHover: boxBl },
  { to: '/portfolio', label: '블로그', icon: blog, iconHover: blogBl },
  { to: '/portfolio', label: '판촉물', icon: mall, iconHover: mallBl },
];

const AUTO_MS = 5600;

function useInView<T extends HTMLElement>() {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return { ref, inView };
}

function PortfolioCard({ item, delay }: { item: PortfolioItem; delay: number }) {
  const { ref, inView } = useInView<HTMLAnchorElement>();
  const sizeClass = item.size === 'hero' ? styles.pfHero : item.size === 'mid' ? styles.pfMid : '';

  return (
    <Link
      ref={ref}
      to="/works"
      className={`${styles.pfCard} ${sizeClass} ${styles.reveal} ${inView ? styles.in : ''}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className={styles.pfThumb}>
        <img src={item.image} alt={item.alt} />
      </div>
      <div className={styles.pfInfo}>
        <span className={styles.tag}>{item.tag}</span>
        <strong>{item.title}</strong>
        <p>{item.desc}</p>
      </div>
    </Link>
  );
}

function ServiceLinkItem({ item, delay }: { item: ServiceLink; delay: number }) {
  const { ref, inView } = useInView<HTMLLIElement>();

  return (
    <li ref={ref} className={`${styles.slink} ${styles.reveal} ${inView ? styles.in : ''}`} style={{ transitionDelay: `${delay}ms` }}>
      <span className={styles.ic}>
        <img src={item.icon} alt="" className={styles.icDefault} />
        <img src={item.iconHover} alt="" className={styles.icHover} />
      </span>
      <span className={styles.slinkLabel}>{item.label}</span>
      <Link to={item.to} className={styles.go} aria-label={`${item.label} 바로가기`}>
        →
      </Link>
    </li>
  );
}

function Home() {
  const [idx, setIdx] = useState(0);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const restart = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setIdx((prev) => (prev + 1) % HERO_SLIDES.length);
    }, AUTO_MS);
  };

  useEffect(() => {
    restart();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const pause = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };

  const goTo = (n: number) => {
    setIdx((n + HERO_SLIDES.length) % HERO_SLIDES.length);
    restart();
  };

  const sectionHead = useInView<HTMLDivElement>();
  const serviceIntro = useInView<HTMLDivElement>();
  const quickBar = useInView<HTMLDivElement>();
  const promoDark = useInView<HTMLAnchorElement>();
  const promoLav = useInView<HTMLAnchorElement>();

  return (
    <div className={styles.page}>
      {/* HERO */}
      <section className={styles.hero} onMouseEnter={pause} onMouseLeave={restart}>
        {HERO_SLIDES.map((slide, i) => (
          <div key={slide.id} className={`${styles.slide} ${i === idx ? styles.isActive : ''}`}>
            <img className={styles.slideBg} src={slide.image} alt={slide.alt} />
            <div className={`${styles.slideScrim} ${slide.scrim}`} />
            <div className={styles.heroInner}>
              <div className={styles.heroText}>
                <h2 className={styles.heroTitle}>{slide.title}</h2>
                <p className={styles.sub}>{slide.sub}</p>
                <div className={styles.btns}>
                  <Link to={slide.primary.to} className={styles.btnDark}>
                    <i className={slide.primary.icon} />
                    {slide.primary.label}
                  </Link>
                  <Link to={slide.secondary.to} className={styles.btnLine}>
                    <i className={slide.secondary.icon} />
                    {slide.secondary.label}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className={styles.sliderNav}>
          <div className={styles.heroCount}>
            <span>{String(idx + 1).padStart(2, '0')}</span> / <span>{String(HERO_SLIDES.length).padStart(2, '0')}</span>
          </div>
          <button type="button" className={styles.arrow} aria-label="이전 슬라이드" onClick={() => goTo(idx - 1)}>
            ←
          </button>
          <button type="button" className={styles.arrow} aria-label="다음 슬라이드" onClick={() => goTo(idx + 1)}>
            →
          </button>
        </div>
      </section>

      {/* PORTFOLIO */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div
            ref={sectionHead.ref}
            className={`${styles.sectionHead} ${styles.reveal} ${sectionHead.inView ? styles.in : ''}`}
          >
            <div>
              <span className={styles.eyebrow}>Portfolio</span>
              <h3 className={styles.sectionTitle}>선택이 아닌, 필연이 되는 디자인</h3>
              <p className={styles.desc}>디자인 전문가들이 제안하는 트렌디한 포트폴리오를 소개합니다.</p>
            </div>
            <Link to="/works" className={styles.more}>
              전체보기 <span className={styles.ar}>→</span>
            </Link>
          </div>

          <div className={styles.pfGrid}>
            {PORTFOLIO_ITEMS.map((item, i) => (
              <PortfolioCard key={item.title} item={item} delay={(i % 3) * 110} />
            ))}
          </div>
        </div>
      </section>

      {/* PROMOTION */}
      <section className={styles.promo}>
        <Link
          ref={promoDark.ref}
          to="/portfolio"
          className={`${styles.promoCard} ${styles.promoDark} ${styles.reveal} ${promoDark.inView ? styles.in : ''}`}
        >
          <span className={styles.eyebrow}>Promotion Mall</span>
          <h4 className={styles.promoTitle}>기성 판촉물은 전용 몰에서 바로</h4>
          <p className={styles.promoDesc}>
            디자인 제작과 별도로 운영되는 판촉물 전용 몰입니다.
            <br /> 주문 내역과 결제는 메인 사이트와 독립적으로 처리되며,
            <br /> 편리한 쇼핑을 위해 새 창에서 열립니다.
          </p>
          <span className={styles.promoLink}>
            판촉물 바로가기 <span className={styles.ar}>→</span>
          </span>
        </Link>

        <Link
          ref={promoLav.ref}
          to="/quote"
          className={`${styles.promoCard} ${styles.promoLav} ${styles.reveal} ${promoLav.inView ? styles.in : ''}`}
        >
          <span className={styles.eyebrow}>Quick &amp; Contact</span>
          <h4 className={styles.promoTitle}>
            제작이 필요하신가요?
            <br />
            견적을 요청해 보세요.
          </h4>
          <p className={styles.promoDesc}>
            견적 신청 후에는 선시안·후결제 또는 선결제 옵션을 선택할 수 있으며,
            <br /> 마이페이지에서 언제든 주문 내역과 시안을 확인할 수 있습니다.
          </p>
          <span className={styles.promoLink}>
            견적 문의하기 <span className={styles.ar}>→</span>
          </span>
        </Link>
      </section>

      {/* SERVICE */}
      <section className={styles.section} id="service">
        <div className={styles.container}>
          <div className={styles.serviceRow}>
            <div
              ref={serviceIntro.ref}
              className={`${styles.serviceIntro} ${styles.revealLeft} ${serviceIntro.inView ? styles.in : ''}`}
            >
              <h3>빠른 조회 서비스</h3>
              <p>
                패키지 제작이 필요하신가요?
                <br />
                상담부터 제작까지 빠르게 도와드립니다.
              </p>
            </div>
            <ul className={styles.serviceLinks}>
              {SERVICE_LINKS.map((item, i) => (
                <ServiceLinkItem key={item.label} item={item} delay={(i % 4) * 110} />
              ))}
            </ul>
          </div>

          <div ref={quickBar.ref} className={`${styles.quick} ${styles.reveal} ${quickBar.inView ? styles.in : ''}`}>
            <div className={styles.quickItem}>
              <span className={styles.ic}>
                <i className="xi-call" />
              </span>
              <div>
                <small>Tel.</small>
                <b>053-216-4126</b>
              </div>
            </div>
            <div className={styles.quickItem}>
              <span className={styles.ic}>
                <i className="xi-mail-o" />
              </span>
              <div>
                <small>E-mail.</small>
                <b>gn-co@daum.net</b>
              </div>
            </div>
            <div className={styles.quickItem}>
              <span className={styles.ic}>
                <i className="xi-clock-o" />
              </span>
              <div>
                <small>Mon-Fri</small>
                <b>
                  09:00 - 18:00 <em>주말·공휴일 휴무</em>
                </b>
              </div>
            </div>
            {/* 카카오톡 채널 상담 (외부 링크: 새 탭) */}
            <a href="https://pf.kakao.com/_KQTpj" target="_blank" rel="noopener noreferrer" className={styles.btnDark}>
              카카오톡 상담 →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
